// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-column[data-v-7a341ec8] {\n  position: sticky;\n  top: 10px;\n  max-height: 95vh;\n}", ""]);
// Exports
module.exports = exports;
